import { createRouter, createWebHistory } from "vue-router"

import { useAuthStore } from '../stores/auth'
import AuctionCalendarsView from "../views/AuctionCalendarsView.vue"
import AuctionsView from "../views/AuctionsView.vue"
import AuctionView from "../views/AuctionView.vue"
import DashboardView from "../views/DashboardView.vue"
import HomeView from "../views/HomeView.vue"
import LoginView from "../views/LoginView.vue"
import LogoutView from "../views/LogoutView.vue"
import ProfileView from "../views/ProfileView.vue"
import SelectionSitesView from "../views/SelectionSitesView.vue"
import SubscribersView from "../views/SubscribersView.vue"

const guest = function (to, from, next) {
  const authStore = useAuthStore()
  // console.log('guest', from, to);
  if (!authStore.isAuthenticated) {
    next();
  } else {
    next('/aste');
  }
}

const auth = function (to, from, next) {
  const authStore = useAuthStore()
  //  console.log('auth', from, to);
  if (authStore.isAuthenticated) {
    next();
  } else {
    next('/logout');
  }
}

const auction = function (to, from, next) {
  const authStore = useAuthStore()
  //  console.log('auth', from, to);
  if (authStore.canAuction) {
    next();
  } else {
    next('/logout');
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
      beforeEnter: guest
    }, {
      path: "/login",
      name: "login",
      component: LoginView,
      beforeEnter: guest
    }, {
      path: "/logout",
      name: "logout",
      component: LogoutView
    }, {
      path: "/profilo",
      name: "profile",
      component: ProfileView,
      beforeEnter: auth
    }, {
      path: "/aste",
      name: "auctions",
      component: AuctionsView,
      beforeEnter: auction
    }, {
      path: "/aste/:id",
      name: "auction",
      component: AuctionView,
      beforeEnter: auction
    }, {
      path: "/iscritti",
      name: "subscribers",
      component: SubscribersView,
      beforeEnter: auth
    }, {
      path: "/centri-selezione",
      name: "selection_sites",
      component: SelectionSitesView,
      beforeEnter: auth
    }, {
      path: "/calendario-aste",
      name: "auction_calendars",
      component: AuctionCalendarsView,
      beforeEnter: auction
    }
  ],
});

export default router;